import type { OutlookSpaceId, ProjectId } from 'owa-timestream-types';

export default function getProjectId(
    tenant: string | null | undefined,
    mailbox: string | null | undefined,
    outlookSpaceId: OutlookSpaceId
): ProjectId {
    return (tenant && mailbox
        ? `${tenant}/${mailbox}/${outlookSpaceId}`
        : outlookSpaceId) as ProjectId;
}
